document.addEventListener('DOMContentLoaded', function() {
  function wrapSPBSelects() {
    document.querySelectorAll('select.spb-productdescfont').forEach(function(sel) {
      if (!sel.parentElement.classList.contains('spb-select-wrapper')) {
        var wrapper = document.createElement('div');
        wrapper.className = 'spb-select-wrapper';
        sel.parentNode.insertBefore(wrapper, sel);
        wrapper.appendChild(sel);
      }
    });
  }
  wrapSPBSelects();
  // Re-run if Infinite Options loads asynchronously
  new MutationObserver(wrapSPBSelects).observe(document.body, { childList: true, subtree: true });
});